import { render } from "./AdpBreadcrumb.vue?vue&type=template&id=2f04b8b0"
import script from "./AdpBreadcrumb.vue?vue&type=script&lang=js"
export * from "./AdpBreadcrumb.vue?vue&type=script&lang=js"

import "./AdpBreadcrumb.vue?vue&type=style&index=0&id=2f04b8b0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__